import { isEmailValid } from './email';

const isValidWebAddress = (address): boolean => {
  const webAddressRegex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/\S*)?$/;
  return webAddressRegex.test(address);
};

export function validateName(name: string): string | null {
  const NAME_MAX_LENGTH = 50;

  if (!name || name.trim() === '') {
    return 'This field is required';
  }
  if (name.length > NAME_MAX_LENGTH) {
    return `Maximum ${NAME_MAX_LENGTH} characters`;
  }
  if (isEmailValid(name) || isValidWebAddress(name)) {
    return 'Name cannot contain email or link';
  }
  return null;
}
